<div class="w100 p15 bg-white">
  <div class="font14 bold html" [innerHTML]="notification.subject"></div>
  <div *ngIf="text !== notification.subject" class="mT15 html" [innerHTML]="text"></div>
  <div class="mT15 df" style="flex-wrap: wrap; justify-content: center">
  <div class="mT15 df" style="flex-wrap: wrap; justify-content: center">
    <ng-container *ngIf="notification.category !== 'ticket'">
      <cs-button *ngFor="let input of notification.inputs || []" (callback)="onClickInputButton(input)" [class]="'m2 primary btn-xxs ' + input.css">
        <cs-button-text>{{ input.text }}</cs-button-text>
      </cs-button>
    </ng-container>
  
    <cs-button *ngIf="notification.openURL" (callback)="navigateToURL()" [class]="'m2 primary btn-xxs'">
      <cs-button-text i18n="@@view">View</cs-button-text>
    </cs-button>
  </div>
  </div>
</div>